import React, { useEffect } from 'react';
import './livetv-player.m.css';
import get from 'lodash/get';
import { connect } from 'react-redux';

const LiveTVPlayer = ({ liveStreamUrl, ...props }) => {
  useEffect(() => { }, []);

  // Add query params to the liveStreamUrl
  const urlWithParams = liveStreamUrl.includes('?')
    ? `${liveStreamUrl}&mute=0&mutestart=0`
    : `${liveStreamUrl}?mute=0&mutestart=0`;

  return (
    <iframe
      src={urlWithParams}
      frameBorder="0"
      width="100%"
      height="100%"
      allowFullScreen
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      {...props}
    ></iframe>
  );
};

const mapStateToProps = (state) => {
  return {
    liveStreamUrl: get(
      state,
      ['qt', 'config', 'publisher', 'live_stream_url'],
      ['https://dai.google.com/linear/hls/event/QuU6z3GSTDaXuLL9Hs5A5Q/master.m3u8'],
    ),
  };
};

export default connect(mapStateToProps)(LiveTVPlayer);
